import React from 'react';
import { Link } from 'react-router-dom';
import { ZapIcon } from 'lucide-react';
export function Logo({
  inverted = false
}: {
  inverted?: boolean;
}) {
  return <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="Ampra Energy home" data-id="element-253" data-mp="y91xcrwomtby">
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-volt" data-id="element-254" data-mp="tdw9hnjpz4l8">
        <ZapIcon className="h-[18px] w-[18px] text-ink" strokeWidth={2.5} fill="currentColor" aria-hidden="true" data-id="element-255" data-mp="ocgti9wefo9p" />
      </span>
      <span className={`text-xl font-extrabold tracking-tight ${inverted ? 'text-white' : 'text-ink'}`} data-id="element-256" data-mp="fkev0h5w4i22">
        ampra<span className={inverted ? 'text-volt' : 'text-muted'} data-id="element-257" data-mp="al25fonmwwvs">.</span>
      </span>
    </Link>;
}